import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Slide,
} from "@mui/material"
import React, { useState } from "react"
import CloseIcon from "@mui/icons-material/Close"
import { useTranslation } from "react-i18next"
import { styles } from "./SubmitSuccess.styles"
import Lottie from "react-lottie"
import animationData from "assets/lottie/ThumbsUp.json"
import TextToolBar from "components/ActivityContent/TextComprehesion/TextToolBar"

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

export default function SubmitSuccess({ open, onClose, onSubmit }) {
  const { t } = useTranslation()
  const [fontSettings, setFontSettings] = useState({
    fontSize: undefined,
    fontFamily: undefined,
    bgColor: undefined,
  })

  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      fullWidth
      PaperProps={{
        sx: [
          styles.paper,
          fontSettings.fontFamily && {
            "& .MuiTypography-root, button, textarea": {
              fontFamily: fontSettings.fontFamily,
            },
          },
        ],
      }}
    >
      <Box display={"none"}>
        <TextToolBar
          updateFontStyle={(fontFamily) =>
            setFontSettings((prev) => ({ ...prev, fontFamily }))
          }
          updateFontSize={(fontSize) =>
            setFontSettings((prev) => ({ ...prev, fontSize }))
          }
          updateBgColor={(bgColor) =>
            setFontSettings((prev) => ({ ...prev, bgColor }))
          }
        />
      </Box>
      <IconButton aria-label="close" onClick={onClose} sx={styles.closeButton}>
        <CloseIcon fontSize="large" />
      </IconButton>
      <DialogContent
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "transparent",
        }}
      >
        <Box
          sx={{
            backgroundColor: "white",
            borderRadius: "50%",
            padding: "20px",
            width: 200,
            height: 200,
          }}
        >
          <Lottie
            options={{
              loop: true,
              autoplay: true,
              animationData: animationData,
              rendererSettings: {
                preserveAspectRatio: "xMidYMid slice",
              },
            }}
            // height={200}
            // width={2000}
            isStopped={false}
            isPaused={false}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          disableElevation
          onClick={onClose}
          sx={styles.button}
        >
          {t("close")}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
